import React, { useEffect, useState } from "react";
import { Card, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { getReportDetail } from '../../../api/revenueService';
export default function ViewRevenue() {
  const [reportData, setReportData] = useState({
    period: '',
    totalRevenue: 0,
    newSubscriptions: 0,
    cancellations: 0,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const period = queryParams.get('period');


  useEffect(() => {
    async function fetchReportDetail() {
      try {
        const response = await getReportDetail(period);
        if (response.success) {
          setReportData({
            period: response.period,
            totalRevenue: response.totalRevenue,
            newSubscriptions: response.newSubscriptions,
            cancellations: response.cancellations,
          });
        } else {
          console.error("Failed to fetch report details");
        }
      } catch (error) {
        console.error("Error fetching report details:", error);
      }
    }

    fetchReportDetail();
  }, [period]);

  const Talefiledata = [
    {
      id: 1,
      Title: 'Period',
      subtitle: reportData.period,
    },
    {
      id: 2,
      Title: 'Total Revenue',
      subtitle: `$${reportData.totalRevenue.toFixed(2)}`,
    },
    {
      id: 3,
      Title: 'Number of New Subscriptions',
      subtitle: reportData.newSubscriptions,
    },
    {
      id: 4,
      Title: 'Number of Cancellations',
      subtitle: reportData.cancellations,
    },
  ];

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>Revenue Report Details</h5>
          <Link className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140" to="/revenue-reports">Back</Link>
        </Card.Header>
        <Card.Body className="taledtl_div mt-3">
          <Row>
            <Col md="12">
              <div className="talefile_list">
                {Talefiledata.map((item) => (
                  <div className="tablefilelist_grid" key={item.id}>
                    <h4>{item.Title}</h4>
                    <p>{item.subtitle}</p>
                  </div>
                ))}
              </div>                           
            </Col>
          </Row>
        </Card.Body>
      </Card> 
    </React.Fragment>
  );
}
